module.exports = __webpack_public_path__ + "static/media/hostsearch-icon.2be6b185.png";